import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';
import { Plus } from 'lucide-react';

export const AdvanceFormDialog = ({
  open,
  onOpenChange,
  workers,
  formData,
  setFormData,
  onSubmit,
  isSubmitting,
  symbol
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button
        data-testid="add-advance-btn"
        className="h-12 px-6 bg-[#D97706] hover:bg-[#B45309] text-white font-semibold"
      >
        <Plus className="w-5 h-5 mr-2" />
        Give Advance
      </Button>
    </DialogTrigger>
    <DialogContent className="sm:max-w-md max-h-[92vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-[#1C1C1E]" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Record Advance Payment
        </DialogTitle>
        <DialogDescription className="text-[#5C5C5C]">
          Log money paid to a worker in advance of their wages.
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Worker *</Label>
          <Select
            value={formData.worker_id}
            onValueChange={(value) => setFormData({ ...formData, worker_id: value })}
          >
            <SelectTrigger data-testid="advance-worker-select" className="h-12 border-[#D1D1CD]">
              <SelectValue placeholder="Select worker" />
            </SelectTrigger>
            <SelectContent>
              {workers.map(worker => (
                <SelectItem key={worker.id} value={worker.id}>
                  {worker.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Amount ({symbol}) *</Label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5C5C] font-medium">
              {symbol}
            </span>
            <Input
              type="number"
              min="1"
              data-testid="advance-amount-input"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              placeholder="Enter amount"
              className="pl-10 h-12 border-[#D1D1CD]"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>Reason</Label>
          <Textarea
            data-testid="advance-reason-input"
            value={formData.reason}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
            placeholder="Optional reason for advance"
            className="border-[#D1D1CD]"
            rows={3}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1 h-12 border-[#D1D1CD]"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            data-testid="advance-submit-btn"
            disabled={isSubmitting}
            className="flex-1 h-12 bg-[#D97706] hover:bg-[#B45309] text-white"
          >
            {isSubmitting ? 'Recording...' : 'Record Advance'}
          </Button>
        </div>
      </form>
    </DialogContent>
  </Dialog>
);
